module.exports = __webpack_public_path__ + "f29d4e5197a483a8d820d0aa6033d785.fbx";